import { newToast } from '../components';
import useApi from '../utils/axios-pettitions';
import { useAppDispatch } from '../contexts/hooks';
import { setMode } from '../contexts/slices/preorders';

export const useApiPreorders = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();

  const Create = async (data: any) => {
    return runApi('Preordenes/Create', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        dispatch(setMode({ mode: 'view', idPreOrder: res.data.POrd_Id }));
        return res.data;
      }
      return [];
    });
  };

  const CreateFromQuotation = async (data: any) => {
    return runApi('Preordenes/CreateFromQuotation', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        dispatch(setMode({ mode: 'view', idPreOrder: res.data.POrd_Id }));
        return res.data;
      }
      return [];
    });
  };

  const GetById = async (idPreorden) => {
    return runApi('Preordenes/GetById', 'GET', { idPreorden }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return null;
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return null;
    });
  };

  const GetByFilter = async (filters: any) => {
    return runApi('Preordenes/GetByFilter', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const deletePr = async (id: number) => {
    return runApi('Preordenes/Delete', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  const Edit = async (data: any, idPreorden: number) => {
    return runApi('Preordenes/Edit', 'POST', { idPreorden }, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.messageDetails, 5);
        return [];
      } else if (res.internalCode === 107) {
        if(res.warnings){
          newToast('WARNING', res.warnings, 5);
        }
        else{
          newToast('SUCCESS', res.message, 3);
        }
        dispatch(setMode({ mode: 'view', idPreOrder: idPreorden }));
        return res.data;
      }
      return [];
    });
  };

  // Consultar las notas de una preorden
  const GetNotes = async (idPreorden: number) => {
    return runApi('Preordenes/GetNotesByIdPreorden', 'GET', { idPreorden }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  }

  // Crear una nota
  const NewNote = async (idPreorden: number, nota: string) => {    
    return runApi('Preordenes/NewNote', 'POST', {idPreorden: idPreorden, nota:nota }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return [];
    });
  };

  // Actualizar una nota
  const EditNote = async (idNota: number, nota: string) => {
    return runApi('Preordenes/EditNote', 'POST', { idNota, nota }, null).then((res) => {
      if (res.internalCode >= 200) {        
        return false;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  // Eliminar una nota
  const DeleteNote = async (idNota: number) => {
    return runApi('Preordenes/DeleteNote', 'POST', { idNota }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return false;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  return {
    Create,
    CreateFromQuotation,
    GetByFilter,
    GetById,
    deletePr,
    Edit,
    GetNotes,
    NewNote,
    EditNote,
    DeleteNote,
  };
};
